import { gql } from '@apollo/client';

export const DELETE_LEASING_EXPENSE_TYPE = gql`
  mutation deleteLeasingExpenseType($expenseTypeId: Int!) {
    deleteLeasingExpenseType(expenseTypeId: $expenseTypeId) {
      commandId
    }
  }
`;
